export interface OauthFlowParams {
  finalize_url: string;
}
export interface CompleteState {
  displayName: string;
  newPassword: string;
  maxMonthlyOrders?: string;
  phone?: string;
  hideExtraData?: boolean;
  originalParams: OauthFlowParams;
  weakPassPopover: boolean;
  saving: boolean;
};

export const initialCompleteState: CompleteState = {
  displayName: '',
  newPassword: '',
  originalParams: {
    finalize_url: ''
  },
  weakPassPopover: false,
  saving: false
};

export function cloneState(other: CompleteState): CompleteState {
  return Object.assign({}, other);
}
